import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Job } from './job.resource';
import { Platform } from './platform.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { EndUserProviderJobConfig } from 'src/app/shared/tools/search/search-config';
import { AtomService } from '../atom.service';

@Resource({
  type: 'platformcapabilities',
})
export class PlatformCapability extends AtomResource {
  @Attribute() cancel?: boolean;
  @Attribute() expire?: boolean;
  @Attribute() refund?: boolean;
  @Attribute({ key: 'refund_duration' }) refundDuration?: string;
  @Attribute({ key: 'silent_hours' }) silentHours?: Range[];
  @Attribute() data?: Record<string, unknown>;

  @Relationship() enduserproviderjob?: Job;
  @Relationship() platform?: Platform;
}
export class PlatformCapabilityConfig implements ResourceConfig {
  hosted = 'platform';
  tables = {
    options: {
      copy: true,
    },
    includes: [
      'enduserproviderjob.firm.headquarterscountry',
      'enduserproviderjob.activity',
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'firm',
        displayedDatas: [
          {
            path: [
              'enduserproviderjob.firm.headquarterscountry.id',
              'enduserproviderjob.firm.name',
            ],
            class: 'label',
          },
          {
            path: ['enduserproviderjob.activity.name'],
            class: 'label',
          },
        ],
        header: 'Name / Label',
        displayed: true,
        link: {
          resource: 'firms',
          filter: 'enduserproviderjob.firm.id',
        },
        options: {
          flag: 'enduserproviderjob.firm.headquarterscountry.id',
        },
      },
      {
        columnDef: 'cancel',
        displayedDatas: [{ path: ['cancel'], type: 'boolean' }],
        header: 'Cancel',
        displayed: true,
      },
      {
        columnDef: 'expire',
        displayedDatas: [{ path: ['expire'], type: 'boolean' }],
        header: 'Expire',
        displayed: true,
      },
      {
        columnDef: 'refund',
        displayedDatas: [{ path: ['refund'], type: 'boolean' }],
        header: 'Refund',
        displayed: true,
      },
      {
        columnDef: 'refundDuration',
        displayedDatas: [{ path: ['refundDuration'], interval: true }],
        header: 'Refund Duration',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        translatable: false,
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'dns',
      title: [
        {
          path: [
            'enduserproviderjob.firm.headquarterscountry.id',
            'enduserproviderjob.firm.name',
          ],
        },
      ],
      subtitle: [
        {
          path: ['enduserproviderjob.activity.name'],
        },
      ],
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            title: 'Cancel',
            APIKey: 'cancel',
            value: {
              path: ['cancel'],
              type: 'boolean',
            },
          },
          {
            title: 'Expire',
            APIKey: 'expire',
            value: {
              path: ['expire'],
              type: 'boolean',
            },
          },
          {
            title: 'refund',
            APIKey: 'refund',
            value: {
              path: ['refundDuration'],
              type: 'interval',
            },
          },
          {
            title: 'Data',
            type: 'data',
            APIKey: 'data',
            value: {
              path: ['data'],
            },
          },
        ],
      },
    ],
  };
  wizard = {
    tabs: [
      {
        title: 'Capabilities',
        formGroup: 'capabilities',
        list: [
          {
            type: 'resource',
            title: 'Firm Job',
            formControl: 'enduserproviderjob',
            APIKey: 'enduserproviderjob',
            search: new EndUserProviderJobConfig(this.atom),
            multiple: false,
            required: true,
            noCols: true,
            filter: [
              {
                key: 'exclude.id',
                value: 'enduserproviderjob.id',
                multiple: 'platform.platformcapabilities',
              },
              {
                key: 'equal.activity.id',
                fixValue: '2,3,4',
              },
            ],
            activatingSequence: [
              {
                group: 'capabilities',
                control: 'cancel',
              },
              {
                group: 'capabilities',
                control: 'expire',
              },
              {
                group: 'capabilities',
                control: 'refund',
              },
            ],
          },
          {
            type: 'boolean',
            title: 'Cancel',
            APIKey: 'cancel',
            formControl: 'cancel',
            noCols: true,
          },
          {
            type: 'boolean',
            title: 'Expire',
            APIKey: 'expire',
            formControl: 'expire',
            noCols: true,
          },
          {
            type: 'boolean',
            title: 'Refund',
            APIKey: 'refund',
            formControl: 'refund',
            noCols: true,
            activatingSequence: [
              {
                group: 'capabilities',
                control: 'refundDuration',
              },
            ],
          },
          {
            type: 'interval',
            title: 'Refund Duration',
            formControl: 'refundDuration',
            APIKey: 'refundDuration',
          },
        ],
      },
      {
        title: "Custom's Datas",
        formGroup: 'data',
        list: [
          {
            type: 'data',
            title: 'Data',
            formControl: 'data',
            required: false,
          },
        ],
      },
    ],
  };
  constructor(private atom: AtomService) {}
  resource = PlatformCapability;
  resourceName = 'Platform Capabilities';
  resourceKey = 'platformcapabilities';
  resourceKeySingle = 'platformcapability';
  includes = [
    'platform.platformcapabilities.enduserproviderjob.firm.headquarterscountry',
    'platform.platformcapabilities.enduserproviderjob.activity',
  ];
}
